export var DropShiftHeaderMessageType;
(function (DropShiftHeaderMessageType) {
    DropShiftHeaderMessageType["countdown"] = "countdown";
    DropShiftHeaderMessageType["dropPenalty"] = "dropPenalty";
})(DropShiftHeaderMessageType || (DropShiftHeaderMessageType = {}));
export var DROP_PENALTY_HOURS = 16;
